import { FC, ReactNode } from 'react';
import MobilePhotoHeader from './MobilePhotoHeader';
import MobilePhotoWrapper from './MobilePhotoWrapper';
import PhotoDotsIndicator from './PhotoDotsIndicator/PhotoDotsIndicator';

import styles from './PhotosModalContentMobile.scss';

type Props = {
    onClose: () => void;
    photoContainer: ReactNode;
    totalItems: number;
    currentIndex: number;
    title?: string;
};

const PhotosModalContentMobile: FC<Props> = props => {
    const { currentIndex, onClose, photoContainer, title, totalItems } = props;

    return (
        <>
            <MobilePhotoHeader onCloseModal={onClose} title={title} />
            <MobilePhotoWrapper>{photoContainer}</MobilePhotoWrapper>
            <div className={styles.dotsWrapper}>
                <PhotoDotsIndicator currentIndex={currentIndex} totalItems={totalItems} />
            </div>
        </>
    );
};

export default PhotosModalContentMobile;
